import { HomeSupportBand } from './HomeSupportBand';

/**
 * Home bottom block — never mounts workspace rails / role cabinet cards.
 * Notebook → Calendar → Q&A → Support and Events → Connections → Alliances
 * belong only on /app/* working pages (CabinetWorkspaceFrame / OwnerHomeCabinet).
 * On home, side entries must not expand; HomeSupportBand is route-entry only.
 */
export const HomeDashboard = () => <HomeSupportBand />;
